export const EXECUTE_BUTTON_TEXT = 'EXECUTE JOB';